import {
  ArrayField,
  Datagrid,
  EditButton,
  NumberField,
  Pagination,
  ReferenceManyField,
  Show,
  ShowButton,
  SimpleShowLayout,
  TextField,
  TopToolbar,
  useTranslate
} from 'react-admin'
import  type { ShowProps } from 'react-admin'
import { FormControl, FormHelperText } from '@mui/material'

import { SessionAccountLinkField, SessionEndedByField, SessionScoreField } from '../components/SessionFields'
import { ShortDateField, ShortDateTimeField } from '../components/ShortDateTimeField'
import { TeamChallengeLinkField } from '../components/TeamFields'
import { useCanAccess } from '../core/hooks'
import { CrudActions } from '../types'

const TeamShowActions = (props: any) => {
  const { canAccess } = useCanAccess({ action: CrudActions.UpdateOne, resource: 'team' })
  return <TopToolbar>{canAccess && <EditButton />}</TopToolbar>
}

const TeamShow = (_props: ShowProps) => {
  const translate = useTranslate()
  const { canAccess } = useCanAccess({ action: CrudActions.ReadAll, resource: 'account' })

  return (
    <Show actions={<TeamShowActions />}>
      <SimpleShowLayout>
        <NumberField source="id" />
        <FormControl style={{ display: 'flex', marginBottom: 4 }}>
          <FormHelperText>{translate('resources.team.fields.creationDate')}</FormHelperText>
          <ShortDateField source="creationDate" />
        </FormControl>
        <TextField source="name" />
        <FormControl style={{ display: 'flex', marginBottom: 4 }}>
          <FormHelperText>{translate('resources.team.fields.challenge.name')}</FormHelperText>
          <TeamChallengeLinkField />
        </FormControl>
        <ArrayField source="accounts" label="resources.team.helpers.accounts">
          <Datagrid bulkActionButtons={false}>
            <NumberField source="id" />
            <TextField source="firstName" />
            <TextField source="lastName" />
            <TextField source="pseudo" />
            <TextField source="email" />
            {canAccess && <ShowButton resource="account" />}
          </Datagrid>
        </ArrayField>
        <ReferenceManyField reference="session" target="team.id" label="resources.team.helpers.sessions" pagination={<Pagination />}>
          <Datagrid bulkActionButtons={false}>
            <ShortDateTimeField source="deviceStartDate" />
            <SessionEndedByField source="endedBy" />
            {canAccess && <SessionAccountLinkField source="account.pseudo" sortable={false} />}
            {canAccess && <SessionAccountLinkField source="account.email" sortable={false} />}
            <SessionScoreField label="Score" />
            <ShowButton resource="session" />
          </Datagrid>
        </ReferenceManyField>
      </SimpleShowLayout>
    </Show>
  )
}

export default TeamShow
